import React, { CSSProperties, MouseEvent, ReactElement } from 'react';
import CSS from './ActionBtn.module.scss';

interface IParentProps {
	id?: string;
	children?: ReactElement | string;
	className?: string;
	onClick?: (e: MouseEvent) => unknown;
	style?: CSSProperties;
	disabled?: boolean;
}

const ActionButton = ({ children, onClick, className, style, disabled = false, id }: IParentProps) => {
	const classes = [CSS.ActionBtn, className ? className : ''];
	return (
		<button style={{ ...style }} id={id ? id : undefined} className={classes.join(' ')} disabled={disabled} onClick={(e) => onClick?.(e)}>
			{children}
		</button>
	);
};

export default ActionButton;
